export const baseName = document.querySelector('base') ? new URL(document.head.baseURI).pathname : '/';

export const webAdminBase = baseName;

export const baseUrl = `${webAdminBase}api/_int`;
